<template>
  <div class="px-6">
    <div class="d-flex justify-end mb-4">
      <v-btn
        color="primary"
        @click="openAddDialog"
      >
        {{ $t('tslContractors.notes.add') }}
      </v-btn>
    </div>

    <Loader v-if="loading" />

    <div v-else-if="notes.length === 0" class="text-center py-8 grey--text">
      {{ $t('tslContractors.notes.noNotes') }}
    </div>

    <div v-else>
      <v-card
        v-for="note in notes"
        :key="note.id"
        class="mb-3"
        outlined
      >
        <v-card-text>
          <div class="d-flex justify-space-between align-start mb-2">
            <div>
              <div class="text-caption grey--text">
                {{ formatDate(note.createdDate) }}
              </div>
              <div class="text-caption grey--text">
                {{ $t('tslContractors.notes.author') }}: {{ note.authorName }} {{ note.authorSurname }}
              </div>
            </div>
            <v-btn
              v-if="note.isEditable"
              icon
              small
              @click="openEditDialog(note)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div class="mt-2" style="white-space: pre-wrap;">
            {{ note.content }}
          </div>
        </v-card-text>
      </v-card>

      <div v-if="totalPages > 1" class="d-flex justify-center mt-4">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          @input="loadNotes"
        />
      </div>
    </div>

    <NoteDialog
      v-model="dialogOpen"
      :note="selectedNote"
      @saved="handleNoteSaved"
    />
  </div>
</template>

<script>
import Service from '@/services'
import Loader from '@/components/Loader'
import NoteDialog from './components/NoteDialog.vue'

export default {
  name: 'Notes',
  components: {
    Loader,
    NoteDialog
  },
  props: {
    contractorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      notes: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      dialogOpen: false,
      selectedNote: null
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.totalCount / this.pageSize)
    }
  },
  created () {
    this.loadNotes()
  },
  methods: {
    async loadNotes () {
      this.loading = true
      try {
        const { data } = await Service.get('/TSLContractor/GetNotes', {
          contractorId: this.contractorId,
          page: this.currentPage,
          pageSize: this.pageSize
        })
        this.notes = data.results || []
        this.totalCount = data.count || 0
      } catch (e) {
        console.error('Error loading notes:', e)
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading notes')
      } finally {
        this.loading = false
      }
    },
    openAddDialog () {
      this.selectedNote = null
      this.dialogOpen = true
    },
    openEditDialog (note) {
      this.selectedNote = note
      this.dialogOpen = true
    },
    async handleNoteSaved (noteData) {
      try {
        if (noteData.id) {
          // Update existing note
          await Service.put('/TSLContractor/UpdateNote', {
            contractorId: this.contractorId,
            noteId: noteData.id,
            content: noteData.content
          })
          this.$store.dispatch('setSuccessNotification', this.$t('tslContractors.notes.updateSuccess'))
        } else {
          // Add new note
          await Service.post('/TSLContractor/AddNote', {
            contractorId: this.contractorId,
            content: noteData.content
          })
          this.$store.dispatch('setSuccessNotification', this.$t('tslContractors.notes.addSuccess'))
        }
        await this.loadNotes()
      } catch (e) {
        console.error('Error saving note:', e)
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error saving note')
      }
    },
    formatDate (dateString) {
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  }
}
</script>
